import React, { useEffect, useState } from 'react'
import AdminCustomerShipment from './AdminCustomerShipment.js';
import AdminCustomerNDR from './AdminCustomerNDR.js';
import AdminCustomerEscalation from './AdminCustomerEscalation.js';
import AdminCustomerProfileDetail from './AdminCustomerProfileDetail.js';
import AdminCustomerBilling from './AdminCustomerBilling.js';
import { FaWallet, FaEnvelope, FaUserTag } from 'react-icons/fa';
import { GET_WALLET_BALANCE } from '../../graphql/Query/Wallet.js';
import { useQuery } from '@apollo/client';
import { GET_ORDERS_CUSTOMER_FOR_ADMIN } from '../../graphql/Query/Order.js';



const AdminCustomerHeader = ({ location }) => {
    const tabs = [
        { name: "Shipment", key: "shipment" },
        { name: "NDR", key: "ndr" },
        { name: "Billing", key: "billing" },
        { name: "Escalations", key: "escalations" },
        { name: "Profile Details", key: "profile" },
    ];
    const [activeTab, setActiveTab] = useState(0);
    const { data: walletData } = useQuery(GET_WALLET_BALANCE, {
        variables: {

            customerId: location?.customerId

        },
        fetchPolicy: "cache-and-network"
    });
    const renderTabContent = () => {
        switch (tabs[activeTab].key) {
            case "shipment":
                return <AdminCustomerShipment location={location} />;
            case "ndr":
                return <AdminCustomerNDR location={location} />;
            case "billing":
                return <AdminCustomerBilling location={location} />;
            case "escalations":
                return <AdminCustomerEscalation location={location} />;
            case "profile":
                return <AdminCustomerProfileDetail location={location} />;
            default:
                return null;
        }
    };

    return (
        <div>
            <div className="mt-10 mx-auto px-4 sm:px-6 lg:px-0 ">
                <p className='text-lg font-bold text-slate-900 mb-4'>Seller Details</p>
                <div className="mb-7">
                    {/* Top Info Card */}
                    <div className="w-full p-6 bg-blue-50 border rounded-t-lg flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6 sm:gap-0 transition-all duration-300">

                        {/* Email */}
                        <div className="flex items-start gap-3">
                            <FaEnvelope className="text-blue-400 text-xl mt-1" />
                            <div>
                                <h2 className="font-semibold text-gray-800 break-all">
                                    {location?.email}
                                </h2>
                                <p className="text-sm text-gray-500 mt-1">Registered Email</p>
                            </div>
                        </div>

                        {/* Seller Code */}
                        <div className="flex items-start gap-3">
                            <FaUserTag className="text-blue-400 text-xl mt-1" />
                            <div>
                                <h2 className="font-semibold text-gray-800 break-all">
                                    {location?.SellerId}
                                </h2>
                                <p className="text-sm text-gray-500 mt-1">Seller Code</p>
                            </div>
                        </div>

                        {/* Wallet Balance */}
                        <div className="flex items-start gap-3">
                            <FaWallet className="text-blue-400 text-xl mt-1" />
                            <div className="text-right">
                                <p className="text-sm text-gray-500">Wallet Balance</p>
                                <p className="font-bold text-green-600">₹{Number(walletData?.GetWalletBalanceAmount?.balance.toFixed(2)) ? Number(walletData?.GetWalletBalanceAmount?.balance.toFixed(2)) : 0}</p>
                            </div>
                        </div>
                    </div>

                    {/* Bottom Border Bar */}
                    <div className="w-full h-1 bg-blue-600 rounded-t-none rounded-b-lg mb-6"></div>
                </div>

                <div className="flex border-b flex-wrap">
                    {tabs.map((tab, index) => (
                        <button
                            key={index}
                            onClick={() => setActiveTab(index)}
                            className={`px-4 py-2 text-sm font-semibold whitespace-nowrap
                ${activeTab === index
                                    ? "font-bold border-b-2 border-blue-600 rounded-t-lg text-blue-600 bg-blue-50"
                                    : "text-gray-600"}
                focus:outline-none`}
                        >
                            {tab.name}
                        </button>
                    ))}
                </div>

                <div className="mt-6">
                    {/* {tabs[activeTab].component} */}
                    {renderTabContent()}
                </div>
            </div>
        </div>
    )
}

export default AdminCustomerHeader